/*
 * Public API Surface of ngx-photoswipe
 */

export { LightboxAdapter } from './lib/adpters/lightbox-adapter';
export { NgxPhotoswipeModule } from './lib/ngx-photoswipe.module';
export { GalleryComponent } from './lib/components/gallery/gallery.component';
export { Image } from './lib/models/image.model';
export { GridGap } from './lib/models/grid-gap.enum';
